import type { ShortCode } from '@highereducation/wordpress';
import {
  CarouselShortcodeClient,
  type CarouselShortcodeProps,
} from './CarouselShortcodeClient';

export type { CarouselShortcodeProps } from './CarouselShortcodeClient';
export { CarouselShortcodeClient } from './CarouselShortcodeClient';

export const CarouselShortcode: ShortCode<CarouselShortcodeProps> = {
  component: CarouselShortcodeClient,
};
